export type EnquiryStatus = 'new' | 'in_progress' | 'quoted' | 'closed';

export interface EnquiryFactbookLine {
  volumeName: string;
  quantity: number;
}

export interface Enquiry {
  id: string;
  institutionName: string;
  institutionType: string;
  country: string;
  state: string;
  city: string;
  gstin?: string;
  fullName: string;
  designation?: string;
  officialEmail: string;
  phone: string;
  factbooks: EnquiryFactbookLine[];
  formats: string[];
  requiredBy?: string;
  budgetCycle?: string;
  additionalNotes?: string;
  submittedAt?: string;
  status: EnquiryStatus;
  createdAt?: string;
  updatedAt?: string;
}

export type EnquiryStatusFilter = EnquiryStatus | 'all';

export interface EnquiryListParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  status?: EnquiryStatusFilter;
}

export interface PaginatedEnquiries {
  results: Enquiry[];
  total: number;
  page: string;
  limit: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

export interface UpdateEnquiryStatusPayload {
  status: EnquiryStatus;
}

export interface BulkEnquiryIdsPayload {
  ids: string[];
}

export interface BulkEnquiryStatusPayload extends BulkEnquiryIdsPayload {
  status: EnquiryStatus;
}

export const ENQUIRY_STATUS_OPTIONS: { value: EnquiryStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All statuses' },
  { value: 'new', label: 'New' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'closed', label: 'Closed' },
];
